import React from 'react';
import ReactDOM from 'react-dom';
import Routes from './Routes';

import GlobalStyle from './Styles/GlobalStyles';

ReactDOM.render(
  <>
    <GlobalStyle />
    <Routes />
  </>,
  document.getElementById('root'),
);
